const designed = 72;
/** The narrowest screen the designed view fits across; narrower ones open the view up to keep it. */
const designedAspect = 1.4;
/** Beyond this the ring bends at the edges: a tall phone is better turned sideways. */
const widest = 100;

const across = 2 * Math.atan(Math.tan((designed * Math.PI) / 360) * designedAspect);

/** The camera's vertical field of view in degrees for a screen this wide against its height. */
export function fieldOfView(aspect: number): number {
  if (aspect >= designedAspect) return designed;
  const vertical = (2 * Math.atan(Math.tan(across / 2) / aspect) * 180) / Math.PI;
  return Math.min(widest, vertical);
}
